export class PromiseInspection {
  static create(promise) {
    return new PromiseInspection(promise);
  }
  constructor(promise) {
    this.handleResolve = this.handleResolve.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.promise = promise.then(this.handleResolve).catch(this.handleReject);
    this._value = undefined;
    this._reason = undefined;
    this._isResolved = false;
    this._isRejected = false;
    this._isFulfilled = false;
  }
  handleResolve(value) {
    this._value = value;
    this._isResolved = true;
    this._isFulfilled = true;
  }
  handleReject(reason) {
    this._reason = reason;
    this._isRejected = true;
    this._isFulfilled = false;
  }
  value() {
    return this._value;
  }
  reason() {
    return this._reason;
  }
  isFulfilled() {
    return this._isFulfilled;
  }
  isRejected() {
    return this._isRejected;
  }
  isResolved() {
    return this._isResolved;
  }
  getPromise() {
    return this.promise;
  }
}